import React, { createContext, useState } from 'react';

const VisitsContext = createContext();

const VisitsContextProvider = ({ children }) => {
  const [selectedVisit, setSelectedVisit] = useState({});
  const [selectedSlot, setSelectedSlot] = useState({});
  const [salesTeam, setSalesTeam] = useState({});
  const [brandId, setBrandId] = useState();
  const [appointments, setAppointments] = useState();
  const [selectedAppointment, setSelectedAppointment] = useState();
  const [exhibitorAgenda, setExhibitorAgenda] = useState();
  const [selectedSlots, setSelectedSlots] = useState([]);
  return (
    <VisitsContext.Provider
      value={{
        selectedVisit,
        setSelectedVisit,
        brandId,
        setBrandId,
        selectedSlot,
        setSelectedSlot,
        salesTeam,
        setSalesTeam,
        appointments,
        setAppointments,
        selectedAppointment,
        setSelectedAppointment,
        exhibitorAgenda,
        setExhibitorAgenda,
        selectedSlots,
        setSelectedSlots,
      }}
    >
      {children}
    </VisitsContext.Provider>
  );
};

export { VisitsContextProvider, VisitsContext };
